import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchPrivacyPolicy } from "../../../redux/action/moreAction";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const { privacyPolicy, isLoading } = useSelector(
    (state) => state?.moreReducer
  );

  useEffect(() => {
    dispatch(fetchPrivacyPolicy());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Privacy Policy"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Privacy Policy",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <div class="untree_co-section">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h2 class="section-title text-center pb-5">
                  <strong>{privacyPolicy?.privacy_policy_title ?? ""}</strong>
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="ct_team_info1">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${privacyPolicy?.privacy_policy_description}`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
